import { getCurrentUserEmail } from "Services";
import { GroupUpdatesMessage } from "Types";
import { convertToPackageSummary, createPackageNotification } from "Utils";
import { GetProjectResponse } from "../types";

export const updateGetProjectCache = (
  state: unknown,
  draft: GetProjectResponse,
  message: GroupUpdatesMessage,
  projectId: string,
  notifications: Array<string | number>,
): GetProjectResponse => {
  const currentUser = getCurrentUserEmail(state);

  if (message.entity === "project" && message.action === "updated") {
    const updatedProject = message.data.find(
      (project) => project.project_id === projectId,
    );

    return updatedProject !== undefined ? updatedProject : draft;
  } else if (message.entity === "package") {
    // update package action will be propagated to project update so it is safe to ignore here
    if (message.action === "created") {
      const createdPackages = message.data.filter(
        (item) => item.project_id === projectId,
      );

      if (message.initiated_by !== currentUser) {
        notifications.push(
          createPackageNotification(
            message,
            createdPackages.map((item) => convertToPackageSummary(item)),
          ),
        );
      }
    } else if (message.action === "deleted") {
      const deletedPackages = draft.packages.filter(
        (item) =>
          item.project_id === projectId &&
          message.keys.includes(item.package_id),
      );

      if (deletedPackages.length === 0) return draft;

      if (message.initiated_by !== currentUser) {
        notifications.push(createPackageNotification(message, deletedPackages));
      }
    }
  }

  return draft;
};
